<template>
    <aside :class="{ 'is-collapsed': isCollapsed, open }" v-if="role">
        <IconComponent class="backIcon" icon="back" @click="toggleSideBar" />

        <IconComponent class="close" icon="close" @click="close" />

        <router-link class="homeIcon" to="/">
            <img class="logo" v-if="logo" :src="logo" />
            <h1 class="name" v-else v-text="name"></h1>
        </router-link>

        <div class="menu">
            <router-link :to="{ name: 'Home' }" class="button">
                <IconComponent class="icon" icon="clipboard" />
                <span class="text">{{ $t('dashboard', 1) }}</span>
            </router-link>
            <router-link to="/consumers" class="button" v-if="role == 'admin'">
                <IconComponent class="icon" icon="consumers" />
                <span class="text">{{ $t('consumer', 0) }}</span>
            </router-link>
            <router-link to="/projects" class="button">
                <IconComponent class="icon" icon="file" />
                <span class="text">{{ $t('project', 0) }}</span>
            </router-link>
            <router-link to="/workers" class="button" v-if="role == 'admin'">
                <IconComponent class="icon" icon="workers" />
                <span class="text">{{ $t('worker', 0) }}</span>
            </router-link>
            <router-link to="/services" class="button" v-if="role == 'admin'">
                <IconComponent class="icon" icon="services" />
                <span class="text">{{ $t('service', 0) }}</span>
            </router-link>
            <router-link to="/settings" class="button" v-if="role == 'admin'">
                <IconComponent class="icon" icon="settings" />
                <span class="text">{{ $t('setting', 0) }}</span>
            </router-link>
            <router-link to="/help" class="button help">
                <IconComponent class="help" icon="help" />
                <span class="text">Feedback</span>
            </router-link>
            <div @click="signout" class="button signout">
                <IconComponent class="icon" icon="logout" />
                <span class="text">Sair</span>
            </div>
        </div>
    </aside>
</template>

<script>
import IconComponent from '@/components/Icons.vue'
import { auth } from "../firebaseApp";
import { signOut } from "firebase/auth";

export default {
    name: 'SideBarPage',
    components: {
        IconComponent,
    },
    data() {
        return {
            isCollapsed: false,
        };
    },
    methods: {
        close() {
            return this.$root.mobileMenu = false
        },
        toggleSideBar() {
            this.isCollapsed = !this.isCollapsed
        },
        async signout() {
            try {
                await signOut(auth);
            } catch (error) {
                console.log(error);
            }
        },
    },
    computed: {
        currentUser() {
            return this.$store.state.users.currentUser
        },
        logo() {
            return this.$store.state.instance.logo
        },
        name() {
            return this.$store.state.instance.name
        },
        open() {
            return this.$root.mobileMenu
        },
        role() {
            return this.$store.state.users.role;
        },
    },
    watch: {
        $route() {
            this.$root.mobileMenu = false
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../assets/utilities/_variables.scss';

.close {
    position: absolute;
    top: 2rem;
    right: 1rem;
    width: 2rem;
    height: 2rem;

    @media screen and (min-width: $desktop-min-width) {
        display: none;
    }
}

aside {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 1rem;
    background-color: var(--card-bg);
    color: var(--text-color);
    width: var(--sidebar-width);
    transition: width .2s ease-out;
    z-index: 9000;
    position: relative;

    @media screen and (max-width: $tablet-xl-max-width) {
        position: fixed;
        top: 0;
        left: 0;
        height: var(--vh);
        overflow: hidden;
        transition: .2s ease-out;
        transition-property: transform;
        width: 100%;

        &:not(.open) {
            transform: translateX(-100%);
        }
    }

    &.is-collapsed {
        width: var(--sidebar-collapsed-width);

        .name {
            display: none;
        }

        .button {
            display: flex;
            align-items: center;
            // background-color: rgba(79, 90, 90, 0);
            background-color: rgba(var(--text-color), 0);
            max-width: var(--sidebar-collapsed-width);

            .text {
                display: none;
                transition: visibility 1s, opacity 0.3s linear;
            }
        }

        .backIcon {
            transform: none;
        }
    }

    div {
        &.logo {
            background-image: var(--logo);
        }

        &.name {
            background-image: var(--logo2);
        }
    }

    .button {
        text-decoration: none;
        display: flex;
        align-items: center;
        width: auto;
        height: 50px;
        padding-left: 25px;
        cursor: pointer;
        z-index: 1000;

        .icon {
            width: 20px;
            height: 20px;
            fill: var(--text-color);
            flex-shrink: 0;
        }

        .text {
            text-transform: capitalize;
            color: var(--text-color);
            font-size: 1rem;
            margin-left: 10px;
        }

        &:hover {
            color: var(--black);
        }

        &:focus,
        &.router-link-active {
            width: var(--sidebar-width);
            background-repeat: no-repeat;
            background-size: auto;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                width: 18px;
                background-color: var(--highlight-color);
                clip-path: polygon(0 0, 0 100%, 100% 50%);
            }

            .icon,
            .text {
                color: var(--highlight-color);
                fill: var(--highlight-color);
            }
        }
    }

    .homeIcon {
        display: flex;
        align-items: center;
        height: 4rem;
        gap: .5rem;
        width: 100%;
    }

    .logo {
        width: 100%;
        object-fit: contain;
        max-width: 100%;
        max-height: 100%;
    }

    .logo,
    .name {
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        display: inline-block;
    }

    .name {
        line-height: 1;
        font-size: 1.2rem;
        font-weight: bold;
        margin: 0;

    }

    .backIcon {
        fill: var(--error-color);
        position: absolute;
        width: 25px;
        height: 25px;
        right: -13px;
        top: 30px;
        cursor: pointer;
        transition: 0.2s ease-in-out;
        transform: rotate(180deg);

        @media screen and (max-width: $tablet-max-width) {
            display: none;
        }
    }

    .menu {
        margin: 0 -1rem;
    }

    .signout {
        position: absolute;
        bottom: 15px;

        .text {
            margin: .8em;
        }
    }
}
</style>
